import { MEASUREMENT_SOURCES, STATUS_COLORS, STATUS_LABELS, formatMeasurement, measurementLabelOf, measurementTypeOf } from '../../../domain';
import { READING_FIELDS, buildReadingRow } from './history-table';
/**
 * Os dados do relatorio do dia (B-29), separados do PDF e do presenter.
 *
 * Funcoes puras para serem conferidas sem rede e sem DOM: quem decide QUE celulas se
 * buscam e COMO as leituras se agrupam e daqui, e errar aqui erra o papel.
 */
/** As colunas do resumo: as MESMAS da tabela do dia na tela, sem a hora. */
export const DAY_REPORT_COLUMNS = READING_FIELDS.slice(1);
const TYPE_IDS = DAY_REPORT_COLUMNS.map((column) => Number(column.field));
/** A chave de uma celula no mapa das leituras buscadas. */
export function bucketKey(hour, typeId) {
    return `${hour}|${typeId}`;
}
/**
 * As celulas que precisam ser buscadas: so as que TEM dado.
 *
 * Uma hora sem aquele tipo nao vira requisicao - num dia tipico, mais da metade da
 * grade e vazia. Tipo fora das colunas (o sono, que e do dia e nao da hora) tambem
 * nao: o relatorio e a tabela da tela falam das mesmas medicoes.
 */
export function dayReportJobs(entries) {
    return chronological(entries).flatMap((entry) => TYPE_IDS.filter((typeId) => entry.values?.some((value) => value.measurementTypeId === typeId)).map((typeId) => ({ hour: entry.date, typeId })));
}
/** As horas do relatorio, da primeira para a ultima, cada uma com as suas leituras. */
export function dayReportHours(entries, fetched) {
    return chronological(entries).map((entry) => {
        // A mesma linha que a tela desenha: o resumo do papel nao pode divergir dela.
        const row = buildReadingRow(entry, () => undefined);
        const readings = TYPE_IDS.flatMap((typeId) => (fetched.get(bucketKey(entry.date, typeId)) ?? []).map((reading) => ({ typeId, reading })))
            .sort((a, b) => a.reading.date.localeCompare(b.reading.date))
            .map(({ typeId, reading }) => {
            const withStatus = measurementTypeOf(typeId)?.hasStatus;
            return {
                time: reading.date.slice(11, 19),
                measurement: measurementLabelOf(typeId),
                value: formatMeasurement(typeId, reading.value),
                status: withStatus ? STATUS_LABELS[reading.statusLevel] : undefined,
                color: withStatus ? STATUS_COLORS[reading.statusLevel] : undefined,
                source: MEASUREMENT_SOURCES.find((item) => item.id === reading.measurementSourceId)?.title
            };
        });
        return {
            label: entry.date.slice(11, 16),
            cells: row.cells.map((cell) => ({ text: cell.value, range: cell.range, color: cell.statusColor })),
            readings
        };
    });
}
function chronological(entries) {
    return [...entries].sort((a, b) => a.date.localeCompare(b.date));
}
//# sourceMappingURL=day-report.js.map